<template>
  <CustomLoader v-if="show" :fullPage="false" :no_text="true" :height="height" type="spinner" />
</template>

<script>
import CustomLoader from '@/components/service/CustomLoader';

// Локальный лоадер блока (режим 'own'): крутилка внутри секции, пока грузится её
// содержимое. Спиннер появляется с задержкой delay (по умолчанию 250мс) — если
// ответ пришёл раньше, блок просто отрисуется без мигания крутилкой. Канонический
// способ для загрузок в created(): когда на странице несколько таких блоков
// грузятся параллельно, быстрые ответы не дают «шторма» из спиннеров.
export default {
  components: { CustomLoader },
  props: {
    // Реактивный флаг «идёт запрос». Держит компонент-владелец (this.xLoading).
    loading: { type: Boolean, default: false },
    height: { type: Number, default: 40 },
    delay: { type: Number, default: 250 },
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    loading: {
      // immediate: блок может смонтироваться, когда loading уже true.
      // Таймер держим лениво на инстансе (не в data — не реактивное состояние),
      // clearTimeout(undefined) в первом проходе безопасен.
      immediate: true,
      handler(val) {
        clearTimeout(this._timer);
        if (val) {
          this._timer = setTimeout(() => { this.show = true; }, this.delay);
        } else {
          this.show = false;
        }
      },
    },
  },
  beforeUnmount() {
    clearTimeout(this._timer);
  },
};
</script>
